import { createFileRoute } from "@tanstack/react-router";
import { Insights } from "@/components/ai/insights";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute("/_authenticated/ai/_layout/insights")({
  component: InsightsComponente,
});

function InsightsComponente() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "ai_insights", actions: ["read"] }]}
    >
      <Insights />
    </RouteGuardPermissions>
  );
}
